<template>
  <div>
        <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="selected_assess=='管理成熟度测评'">管理成熟度测评</el-breadcrumb-item>
            <el-breadcrumb-item v-if="selected_assess=='组织健康度测评'">组织健康度测评</el-breadcrumb-item>
        </el-breadcrumb> -->
        <!-- <div style="width:100%;height:42.67px;margin-bottom:45px;">
            <div class="select_area">
                <span>请选择查询的测评：</span>
                <el-select v-model="selected_assess" placeholder="请选择">
                    <el-option
                    v-for="item in assess_list"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
            </div>
            <div class="search" style="float:right;">
                <el-form :inline="true" :model="formInline">
                <el-form-item>
                <el-input
                placeholder="请输入搜索信息"
                v-model="formInline.search_info"
                clearable>
                </el-input>
                </el-form-item>
                <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
                </el-form-item>
                </el-form>
            </div>
        </div> -->
        <!-- <router-view></router-view> -->
        <!-- <cheng-shu style="position:relative;top:-15px;" ref="chengshu_ref" :query_info="formInline.search_info"></cheng-shu> -->
        <cheng-shu style="position:relative;top:-15px;" :task_id="task_id"></cheng-shu>
        <!-- <jian-kang v-if="this.selected_assess=='组织健康度测评'" style="position:relative;top:-15px;" ref="jiankang_ref"></jian-kang> -->
  </div>
</template>

<script>
import chengShu from "./ChengShu_progress.vue";
// import jianKang from "./JianKang_progress.vue";
import getdata from "@/api/getData.js";
export default {
    components: {
        chengShu,
        // jianKang,
    },
    created() {
        getdata.getList("checklogin")
              .then(() => {
                
              })
              .catch(() => {
                if(localStorage.getItem("token") != null){
                    this.$message({
                        message: '会话超时，请重新登录！',
                        type: 'warning',
                    })
                }
                this.$router.push({
                    path: '/login',
                });
              })
    },
    data() {
        return {
            // selected_assess: '管理成熟度测评',
            // assess_list: ['管理成熟度测评', '组织健康度测评'],
            // formInline: {
            //     search_info: '',
            //     search_result: [],
            // },
        }
    },
    props: ['task_id'],
    methods: {
        // search() {
        //     this.$refs.chengshu_ref.getProgressInfo(this.formInline.search_info);
        // },
    }
}
</script>

<style scoped>
/* .el-breadcrumb {
    font-size: 20px;
    border-left: solid 6px #606266;
    padding-left: 15px;
    margin-bottom: 50px;
} */
/* .select_area {
    text-align: left;
    float: left;
}
.select_area ::v-deep .el-input {
    font-size: 16px;
}
.select_area ::v-deep .el-input__inner {
    height: 42.67px;
    line-height: 42.67px;
} */
/* .search /deep/ .el-input {
    font-size: 16px;
}
.search /deep/ .el-button {
    font-size: 16px;
}
.search /deep/ .el-input__inner {
    height: 42.67px;
    line-height: 42.67px;
} */
::v-deep .el-form-item {
    margin-bottom: 0;
}
</style>